<!--
  SortByFilter renders a filter with dropdown options for sort order
  and reads/writes from the `order` URL query param.
-->

<script>
import {
  iBadgeColours,
  iBadge,
  iMenu,
  iMenuItem,
  iMenuTriggerAlignOptions,
} from '@inscribe/signal';
import { getAndSyncQueryParams, updateQueryParams } from '@/utils/queryParams';

export default {
  components: {
    iBadge,
    iMenu,
    iMenuItem,
  },
  props: {
    className: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      params: getAndSyncQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
      }),
      selectedOrder: null,
      iBadgeColours,
      iMenuTriggerAlignOptions,
      OPTIONS: [
        {
          key: 'created_at',
          label: 'Sort by Date Created Old to New',
        },
        {
          key: '-created_at',
          label: 'Sort by Date Created New to Old',
        },
      ],
    };
  },
  computed: {
    label() {
      return this.selectedOrder ? this.selectedOrder.label : 'Sort by';
    },
  },
  watch: {
    '$route.fullPath': {
      handler: function (newFullPath) {
        this.params = getAndSyncQueryParams({
          fullPath: newFullPath,
          router: this.$router,
          store: this.$store,
        });
      },
    },
  },
  mounted() {
    if (this.params?.order) {
      this.selectedOrder = this.OPTIONS.find(
        (o) => o.key === this.params.order,
      );
    }
  },
  methods: {
    onSelectionChanged(order) {
      this.selectedOrder = order;
      updateQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
        updates: {
          order: this.selectedOrder.key,
        },
      });
    },
  },
};
</script>

<template>
  <div :class="className">
    <i-menu
      :close-on-item-click="true"
      :trigger-align="iMenuTriggerAlignOptions.LEFT"
      trigger-selector=".trigger-badge"
      data-testid="sort-by-filter-menu"
      data-dd-action-name="documents-view-sort-by-filter"
      :width="250"
    >
      <template #trigger>
        <i-badge
          class="trigger-badge"
          :colour="iBadgeColours.NEUTRAL"
          icon="small-chevron-down"
          :has-trailing-icon="true"
          :label="label"
          :interactable="true"
        ></i-badge>
      </template>
      <template #items>
        <i-menu-item
          v-for="option in OPTIONS"
          :key="option.key"
          :label="option.label"
          @item-click="onSelectionChanged(option)"
        />
      </template>
    </i-menu>
  </div>
</template>
